// src/components/TestimonialCard.js
import React from 'react';
import './TestimonialCard.css';

const TestimonialCard = ({ image, name, designation, review }) => {
  return (
    <div className="testimonial-card">
      <img src={image} alt={name} className="testimonial-image" />
      <div className="testimonial-content">
        <h3>{name}</h3>
        <h4>{designation}</h4>
        <p>{review}</p>
      </div>
    </div>
  );
};

export default TestimonialCard;
